import { useState, useEffect } from 'react';
import AboutYouForm from './components/AboutYouForm/AboutYouForm';
import MonthlyIncomeAndExpensesForm from './components/MonthlyIncomeAndExpensesForm/MonthlyIncomeAndExpensesForm';
import OtherDebtForm from './components/OtherDebtForm/OtherDebtForm';
import OtherDebtSummary from './components/OtherDebtSummary/OtherDebtSummary';
import PageLink from 'components/PageLink/PageLink';
import get from 'lodash/get';
import FOOD_EXPENSE from 'templates/IncomeAndExpendituresPageData/Consts/FoodExpense';
import HOUSEHOLD_SITUATION from 'templates/IncomeAndExpendituresPageData/Consts/householdSituation';
import { IIncomeAndExpenditureFormModel } from 'templates/IncomeAndExpendituresPageData/IncomeAndExpenditure';
import styles from './IncomeAndExpendituresPageData.module.scss';
import {
  parseRawNumber,
  formatNumber,
} from 'templates/IncomeAndExpendituresPageData/Utils/FormatNumbers';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';
import { useAppDispatch } from 'app/hooks';
import http from 'app/http';
import { setContent } from 'features/content/reducer';
import { getParamValue } from 'common/helpers/urlParams';
import { getGTMVariables, getGTMVariablesPageView  } from 'common/helpers/Gtm';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const IncomeAndExpendituresPageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  const [IncomeAndExpenditureFormModel, setIncomeAndExpenditureFormModel] =
    useState<IIncomeAndExpenditureFormModel>({
      AboutYouFormModel: {
        peopleInHouse: '',
        houseHoldSituation: '',
        AgeAndGender: [
          {
            age: '',
            gender: '',
          },
        ],
      },
      MonthlyIncomeAndExpensesFormModel: {
        yourIncome: '',
        otherAdultsIncome: '',
        healthcareBenefit: '',
        housingBenefit: '',
        otherIncome: '',
        totalHouseholdIncome: '',
        isExpectingIncomes: '',
        expectedHouseholdIncome: '',
        rentOrMortage: '',

        healthcareInsurance: '',
        utility: '',
        water: '',
        totalInsurance: '',
        tvAndInternet: '',
        mobilePhone: '',
        carCosts: '',
        foodExpense: '',
        monthlyAbility: '',
        otherExpenses: '',
        totalHouseholdExpenses: '',
      },
      OtherDebtFormModel: {
        totalDebtBalances: '',
        totalDebtPayments: '',
        Debts: [{ debtCreditor: '', debtBalance: 0, debtMonthlyPayment: 0 }],
      },
      OtherDebtSummaryFormModel:{
        monthlyPaymentConfirmInput:''
      }
    });
  const [hideOtherAdultsIncome, setHideOtherAdultsIncome] =
    useState<boolean>(false);
  const [disableConfirmBtn, setDisableConfirmBtn] = useState<boolean>(false);
  const [wizardStepIndex, setWizardStep] = useState<number>(1);
  const [step1Completed, setStep1Completed] = useState(false);
  const [step2Completed, setStep2Completed] = useState(false);
  const [step3Completed, setStep3Completed] = useState(false);
  // const [step4Completed, setStep4Completed] = useState(false);
  // const [step1Valid, setStep1Valid] = useState(false);
  // const [step2Valid, setStep2Valid] = useState(false);
  // const [step3Valid, setStep3Valid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isBackhiting, setIsBackhiting] = useState(false);
  const currencyClass = 'Icon-euro--before';
  const usehistory = useHistory();
  const uselocation = useLocation();
  const dispatch = useAppDispatch();
  const { pathname, search } = uselocation;

  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);

    return link.pathname + link.search;
  };
  function getFoodCostRatio(peopleCount: string, member: any) {
    return get(
      FOOD_EXPENSE,
      `${peopleCount}.${member.gender}.${member.age}`,
      0,
    );
  }

  function calculateAverageFoodCost() {
    const peopleRatio =
      IncomeAndExpenditureFormModel?.AboutYouFormModel?.AgeAndGender?.map(
        (item: any) =>
          getFoodCostRatio(
            IncomeAndExpenditureFormModel?.AboutYouFormModel?.peopleInHouse ||
              '',
            item,
          ),
      );
    return (
      30 * (peopleRatio || []).reduce((acc: any, curr: any) => acc + curr, 0)
    );
  }

  function onChangeHouseHoldSituation(val: string) {
    let newFormValues = { ...IncomeAndExpenditureFormModel.AboutYouFormModel };
    newFormValues['houseHoldSituation'] = val;
    setIncomeAndExpenditureFormModel({
      ...IncomeAndExpenditureFormModel,
      AboutYouFormModel: newFormValues,
    });

    if (
      val === HOUSEHOLD_SITUATION.ONE_ADULT ||
      val === HOUSEHOLD_SITUATION.ONE_ADULT_WITH_CHILDREN
    ) {
      setHideOtherAdultsIncome(true);
    } else {
      setHideOtherAdultsIncome(false);
    }
  }

  function validateFormStep1() {
    IncomeAndExpenditureFormModel?.AboutYouFormModel?.AgeAndGender?.map(
      (element: any, index: number) => {
        if (!element.gender || !element.age) {
          return false;
        }
      },
    );
    if (
      IncomeAndExpenditureFormModel?.AboutYouFormModel?.houseHoldSituation &&
      IncomeAndExpenditureFormModel?.AboutYouFormModel?.peopleInHouse
    ) {
      return true;
    }
    return false;
  }

  function validateFormStep2() {
    if (
      IncomeAndExpenditureFormModel?.MonthlyIncomeAndExpensesFormModel
        ?.yourIncome &&
      IncomeAndExpenditureFormModel?.MonthlyIncomeAndExpensesFormModel
        ?.otherAdultsIncome
    ) {
      return true;
    }
    return false;
  }

  function nextButtonClick() {
    setIsSubmitting(true);
    if (wizardStepIndex === 1) {
      if (validateFormStep1()) {
        setStep1Completed(true);
        setIsSubmitting(false);
        setWizardStep(2);
      }
    }
    if (wizardStepIndex === 2) {
      if (validateFormStep2()) {
        setStep2Completed(true);
        setWizardStep(3);
      }
    }
    if (wizardStepIndex === 3) {
      setStep3Completed(true);
      setWizardStep(4);
    }

    //return false;
  }
  function backButtonClick() {
    setIsBackhiting(true);
    if (wizardStepIndex === 2) {
      if (validateFormStep2()) {
        setStep2Completed(true);
        setWizardStep(1);
      }
    }
    if (wizardStepIndex === 3) {
      setStep3Completed(true);
      setWizardStep(2);
    }
    if (wizardStepIndex === 4) {
      setWizardStep(3);
    }
    //return false;
  }

  const submitButtonClick = async (e: any) => {
    let aboutYouFormValues = {
      ...IncomeAndExpenditureFormModel?.AboutYouFormModel,
    };
    let incomeExpenseFormValues = {
      ...IncomeAndExpenditureFormModel?.MonthlyIncomeAndExpensesFormModel,
    };
    let otherDebtFormValues = {
      ...IncomeAndExpenditureFormModel?.OtherDebtFormModel,
    };
    let otherDebtSummaryFormValues = {
      ...IncomeAndExpenditureFormModel?.OtherDebtSummaryFormModel,
    };

    const totalExpenditure =
      parseRawNumber(incomeExpenseFormValues.totalHouseholdExpenses || '', 2) +
      parseRawNumber(otherDebtFormValues.totalDebtPayments || '', 2);
    const availableIncome =
      parseRawNumber(incomeExpenseFormValues.totalHouseholdIncome || '', 2) -
      totalExpenditure;
    const gasElectricityWaterCost =
      parseRawNumber(incomeExpenseFormValues.utility || '', 2) +
      parseRawNumber(incomeExpenseFormValues.water || '', 2);
    const tvInternetMobileCost =
      parseRawNumber(incomeExpenseFormValues?.tvAndInternet || '', 2) +
      parseRawNumber(incomeExpenseFormValues.mobilePhone || '', 2);

    let monthlypaymentAmount = parseRawNumber(
      otherDebtSummaryFormValues.monthlyPaymentConfirmInput || '',
      2,
    );

    let availableIncomeVal: string;
    let monthlypaymentAmountVal: string;
    monthlypaymentAmountVal = formatNumber(monthlypaymentAmount, ',');
    availableIncomeVal =formatNumber(availableIncome, ',');

    let actualIncome = availableIncomeVal;
    let creditorValues = otherDebtFormValues?.Debts?.map((item, index) => ({
      CreditorName: item.debtCreditor,
      CurrentDebt: item.debtBalance,
      RepaymentPerMonth: item.debtMonthlyPayment,
    }));

    let ageValues = aboutYouFormValues?.AgeAndGender?.map(
      (item, index) => item.age,
    );

    setDisableConfirmBtn(true);
    e.preventDefault();
    try {
      const response = await http.post(
        `${pathname}confirm`,
        // Convert object into string
        qs.stringify({
          calculationId: getParamValue(search, 'calculationId'),
          availableIncome: availableIncomeVal,
          age: ageValues,
          yourIncome: formatNumber(
            parseRawNumber(incomeExpenseFormValues.yourIncome || '', 2),
            ',',
          ),
          otherAdultsIncome: formatNumber(
            parseRawNumber(incomeExpenseFormValues.otherAdultsIncome || '', 2),
            ',',
          ),
          healthcareBenefit: formatNumber(
            parseRawNumber(incomeExpenseFormValues.healthcareBenefit || '', 2),
            ',',
          ),
          housingBenefit: formatNumber(
            parseRawNumber(incomeExpenseFormValues.housingBenefit || '', 2),
            ',',
          ),
          otherIncome: formatNumber(
            parseRawNumber(incomeExpenseFormValues.otherIncome || '', 2),
            ',',
          ),
          rentOrMortage: formatNumber(
            parseRawNumber(incomeExpenseFormValues.rentOrMortage || '', 2),
            ',',
          ),
          healthcareInsurance: formatNumber(
            parseRawNumber(
              incomeExpenseFormValues.healthcareInsurance || '',
              2,
            ),
            ',',
          ),
          totalInsurance: formatNumber(
            parseRawNumber(incomeExpenseFormValues.totalInsurance || '', 2),
            ',',
          ),
          carCosts: formatNumber(
            parseRawNumber(incomeExpenseFormValues.carCosts || '', 2),
            ',',
          ),
          gasElectricityWaterCost: formatNumber(gasElectricityWaterCost, ','),
          tvInternetMobileCost: formatNumber(tvInternetMobileCost, ','),
          creditors: creditorValues,
          redirectFromPayerReview: Model?.redirectFromPayerReview,
          actualIncome: actualIncome,
          changedMonthlyPaymentAmount: monthlypaymentAmountVal,
          totalIncome: formatNumber(
            parseRawNumber(incomeExpenseFormValues.totalHouseholdIncome || '', 2),
            ',',
          ),
          totalExpense: formatNumber(
            parseRawNumber(incomeExpenseFormValues.totalHouseholdExpenses || '', 2),
            ',',
          )
        }),
        {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
        },
      );

      if (response && response.data) {
        // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
        const nextPagePath = getPathnameFromUrl(response.data.data);

        usehistory.push(nextPagePath, {
          noRefresh: false,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  function step1WizardClick() {
    setWizardStep(1);
  }
  function step2WizardClick() {
    if (step1Completed) {
      setWizardStep(2);
    }
  }
  function step3WizardClick() {
    if (step2Completed) {
      setWizardStep(3);
    }
  }

  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid = LayoutModel?.Profiles.length>0 ? LayoutModel?.Profiles[0].DebtReference : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env,LayoutModel?.IsLoggedInUserSecured, LayoutModel?.SecuredCaseStatus);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }
    , [LayoutModel]);


  return (
    <div className={styles.wrapper}>
      <div className="IncomeAndExpenditure Section--secondaryBg">
        <div className="Page-container PageContainer--transparent PageContainer--overflow">
          <section className="Section">
            <div id="ieWizard" className="WizardForm">
              <h1 className="Heading">{PageData?.Title}</h1>
              <ul className="nav">
                <li className="nav-item">
                  <a
                    className={
                      'nav-link' +
                      ' ' +
                      (wizardStepIndex === 1
                        ? 'active'
                        : step1Completed
                        ? 'done'
                        : 'inactive')
                    }
                    onClick={step1WizardClick}
                  >
                    <span className="nav-indicator"></span>
                    <span className="nav-link-text">
                      {' '}
                      {PageData?.AboutYouHeader}
                    </span>
                    <span className="nav-link-text nav-link-text--mobile-only">
                      {PageData?.AboutYouHeader}
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={
                      'nav-link' +
                      ' ' +
                      (wizardStepIndex === 2
                        ? 'active'
                        : step2Completed
                        ? 'done'
                        : 'inactive')
                    }
                    onClick={step2WizardClick}
                  >
                    <span className="nav-indicator"></span>
                    <span className="nav-link-text">
                      {PageData?.MonthlyIncomeAndExpensesHeader}
                    </span>
                    <span className="nav-link-text nav-link-text--mobile-only">
                      {PageData?.IncomeOrExpensesHeader}
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={
                      'nav-link' +
                      ' ' +
                      (wizardStepIndex === 3
                        ? 'active'
                        : step3Completed
                        ? 'done'
                        : 'inactive')
                    }
                    onClick={step3WizardClick}
                  >
                    <span className="nav-indicator"></span>
                    <span className="nav-link-text">
                      {PageData?.OtherDebtHeader}
                    </span>
                    <span className="nav-link-text nav-link-text--mobile-only">
                      {PageData?.OtherDebtHeader}
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#step-4">
                    <span className="nav-indicator"></span>
                    <span className="nav-link-text">
                      {PageData?.ConfirmationHeader}
                    </span>
                  </a>
                </li>
              </ul>
              <div className="tab-content">
                {wizardStepIndex === 1 && (
                  <div
                    id="step-1"
                    className="tab-pane"
                    role="tabpanel"
                    aria-labelledby="step-1"
                  >
                    <AboutYouForm
                      IncomeAndExpenditureFormModel={
                        IncomeAndExpenditureFormModel
                      }
                      setIncomeAndExpenditureFormModel={
                        setIncomeAndExpenditureFormModel
                      }
                      onChangeHouseHoldSituation={onChangeHouseHoldSituation}
                      isSubmitting={isSubmitting}
                      {...props}
                    ></AboutYouForm>
                  </div>
                )}

                {wizardStepIndex === 2 && (
                  <div
                    id="step-2"
                    className="tab-pane"
                    role="tabpanel"
                    aria-labelledby="step-2"
                  >
                    <MonthlyIncomeAndExpensesForm
                      IncomeAndExpenditureFormModel={
                        IncomeAndExpenditureFormModel
                      }
                      setIncomeAndExpenditureFormModel={
                        setIncomeAndExpenditureFormModel
                      }
                      currencyClass={currencyClass}
                      averageFoodCost={calculateAverageFoodCost()}
                      hideOtherAdultsIncome={hideOtherAdultsIncome}
                      isSubmitting={isSubmitting}
                      isBackhiting={isBackhiting}
                      {...props}
                    ></MonthlyIncomeAndExpensesForm>
                  </div>
                )}
                {wizardStepIndex === 3 && (
                  <div
                    id="step-3"
                    className="tab-pane"
                    role="tabpanel"
                    aria-labelledby="step-3"
                  >
                    <OtherDebtForm
                      currencyClass={currencyClass}
                      IncomeAndExpenditureFormModel={
                        IncomeAndExpenditureFormModel
                      }
                      setIncomeAndExpenditureFormModel={
                        setIncomeAndExpenditureFormModel
                      }
                      {...props}
                    ></OtherDebtForm>
                  </div>
                )}
                {wizardStepIndex === 4 && (
                  <div
                    id="step-4"
                    className="tab-pane"
                    role="tabpanel"
                    aria-labelledby="step-4"
                  >
                    <div className="IncomeAndExpenditure__confirmation OtherDebt">
                      <p className="IncomeAndExpenditure__formInfo">
                        {PageData?.PleaseConfirmNote}
                      </p>
                      <OtherDebtSummary
                        currencyClass={currencyClass}
                        setDisableConfirmBtn={setDisableConfirmBtn}
                        IncomeAndExpenditureFormModel={
                          IncomeAndExpenditureFormModel
                        }
                        setIncomeAndExpenditureFormModel={
                          setIncomeAndExpenditureFormModel
                        }
                        {...props}
                      ></OtherDebtSummary>
                    </div>
                  </div>
                )}
              </div>
              <div className="ButtonBar  ButtonBar--spaceBetween ButtonBar--row-reverse ">
                {wizardStepIndex !== 4 && (
                  <button
                    className="Button"
                    id="next-btn"
                    onClick={nextButtonClick}
                    type="button"
                  >
                    {PageData?.NextButtonLabel}
                  </button>
                )}
                {wizardStepIndex === 4 && (
                  <button
                    className="Button"
                    id="confirm-btn"
                    onClick={submitButtonClick}
                    type="button"
                    disabled={disableConfirmBtn}
                  >
                    {PageData?.ConfirmLabel}
                  </button>
                )}

                {wizardStepIndex !== 1 && (
                  <button
                    className="Button Button--gray"
                    id="prev-btn"
                    onClick={backButtonClick}
                    type="button"
                  >
                    {PageData?.BackButtonLabel}
                  </button>
                )}

                {wizardStepIndex === 1 && (
                  <PageLink
                    url={Model.BackButtonUrl}
                    text={PageData?.BackButtonLabel}
                    className={'Button Button--gray'}
                  />
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default IncomeAndExpendituresPageData;
